import { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../AppContext";
import { loadClassroomAPI, authenticateClassroomAPI, fetchEvents, getCourses, getAccessToken } from "../classroom";


const useClassroomEvents = (user, homeworks, setHomeworks, timetable) => {
    const { offline } = useContext(AppContext);

    const [newEvents, setNewEvents] = useState(false);
    const [updatedEvents, setUpdatedEvents] = useState(false);

    const firstFetch = useRef();

    useEffect(() => {
        (async () => {
            // console.log("<useClassroom> Loading API: ", offline, user, firstFetch.current, homeworks, timetable, setHomeworks);
            if (offline || !user || firstFetch.current || !setHomeworks || !timetable)
                return;

            // console.log("<useClassroom> Loading API");
            firstFetch.current = true;
            await loadClassroomAPI(user);
            await authenticateClassroomAPI(user);
            // console.log("<useClassroom> Loaded API, fetching events");
            let [classroomNewEvents, classroomUpdatedEvents] = await fetchEvents(offline, homeworks, setHomeworks, timetable, user);
            // console.log("<useClassroom> Fetched events", classroomNewEvents, classroomUpdatedEvents);
            setNewEvents(classroomNewEvents);
            setUpdatedEvents(classroomUpdatedEvents);
        })();
    }, [offline, user, homeworks, timetable, setHomeworks]);
    
    return [newEvents, updatedEvents, setNewEvents, setUpdatedEvents];
};

export {
    useClassroomEvents,
};